import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-all-total-business-report-subscription',
  // standalone: true,
  // imports: [],
  templateUrl: './all-total-business-report-subscription.component.html',
  styleUrl: './all-total-business-report-subscription.component.scss'
})
export class AllTotalBusinessReportSubscriptionComponent implements OnInit {

  offrepwiseData;
     today = new Date();
     startDate = '';
     endDate = '';
     isLoading: boolean = false;
     subTypesName = [
       { name: 'वार्षिक', isVisible: false },
       { name: 'त्रैवार्षिक', isVisible: false },
       { name: 'पंचवार्षिक', isVisible: false },
     ];
     totalth = 0;
     finalData = [];
     off_rep_name;
     appliedFilters: any = {};
   
     constructor(
       public dialogref: MatDialogRef<AllTotalBusinessReportSubscriptionComponent>,
       @Inject(MAT_DIALOG_DATA) public data: any, public service: DigisubservicesService,
     ) {}
   
     ngOnInit(): void {
       this.isLoading = true;
       this.offrepwiseData = this.data['offrepwisedata'];
       this.off_rep_name = this.data['off_rep_name'];
       this.startDate = this.data['startDate'];
       this.endDate = this.data['endDate'];
       // console.log(this.offrepwiseData);
       
      this.appliedFilters = this.data['appliedFilters'] || {};
   
      console.log("Applied Filters:", this.appliedFilters);
   
       let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);
   
       for (let i = 0; i < Object.keys(data).length; i++) {
         let flag = false;
         for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
           if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
             this.subTypesName[j]['isVisible'] = true;
             flag = true;
             break;
           }
         }
         if (!flag) {
           // if (
           //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
           //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
           //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
           //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
           //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
           // ) {
           this.subTypesName.push({
             name: data[i]['subscription_type'],
             isVisible: true,
           });
           // }
         }
       }
   
       // console.log(this.subTypesName);
       // this.totalth = this.subTypesName.length * 4 + 8;
   
        this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 34;
   
       // this.getoffdata();
      //  this.setData();
        // ✅ IMPORTANT: CALL EXPENSE API FIRST
    this.loadExpenseData();
    this.getAllVouchersData();
     }
  
  expenseLedgerData: any[] = [];
  
  getallVouchersData: any[] = [];
  
  loadExpenseData() {
  
    const request = {
      exp_id: 35,
      sub_exp_id: "312",
      startdate: this.startDate,
      enddate: this.endDate
    };
  
    this.service.getExpenseLedgerReportData(request).subscribe({
      next: (res: any) => {
        this.expenseLedgerData = res || [];
        console.log('EXPENSE Ledger Data:', res);
        this.setData();
      },
      error: () => {
        this.expenseLedgerData = [];
        this.setData();
      }
    });
  }
  
  // getAllVouchersData() {
  
  //   const fyStart = this.startDate;
  //   const fyEnd = this.endDate;
  
  //   this.service.getvoucherbySub(fyStart, fyEnd).subscribe(
  //     (res: any) => {
  
  //       console.log('EXPENSE API RESPONSE:', res);
  
  //       // ✅ FIX: handle both cases (array OR object)
  //       this.getallVouchersData = Array.isArray(res)
  //         ? res
  //         : (res?.data || []);
  
  //       console.log('FINAL VOUCHER DATA:', this.getallVouchersData);
  
  //       this.setData();
  //     },
  //     (error: any) => {
  //       console.error('EXPENSE API ERROR:', error);
  
  //       this.getallVouchersData = [];
  //       this.setData();
  //     }
  //   );
  // }

  getAllVouchersData() {

  const fyStart = this.startDate;
  const fyEnd = this.endDate;

  this.service.getvoucherbySub(fyStart, fyEnd).subscribe(

    (res: any) => {

      console.log('EXPENSE API RESPONSE:', res);

      // ✅ HANDLE ARRAY / OBJECT
      this.getallVouchersData = Array.isArray(res)
        ? res
        : (res?.data || []);

      console.log('FINAL VOUCHER DATA:', this.getallVouchersData);

      this.setData();
    },

    (error: any) => {

      console.error('EXPENSE API ERROR:', error);

      this.getallVouchersData = [];

      this.setData();
    }
  );
}

// Existing Correct Code
// setData() {

//   if (!this.offrepwiseData) return;

//   const NET_TYPES = [
//     'वार्षिक',
//     'त्रैवार्षिक',
//     'पंचवार्षिक',
//     'ऑनलाईन अंक सहामाही',
//     'ऑनलाईन अंक वार्षिक'
//   ];

//   const EXCLUDE_YOJANA = [
//     ...NET_TYPES,
//     'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
//   ];

//   const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

//   const normalize = (val: any) =>
//     (val || '')
//       .toString()
//       .trim()
//       .replace(/\s+/g, ' ')
//       .replace(/[^\w\u0900-\u097F ]/g, '')
//       .toLowerCase();

//   const donationMap: any = {};
//   const pendingMap: any = {};

//   (this.getallVouchersData || []).forEach((v: any) => {
//     const rep = normalize(v.rep_name);
//     if (!rep) return;

//     if (!pendingMap[rep]) {
//       pendingMap[rep] = 0;
//     }

//     pendingMap[rep] += Number(v.remaining_amt) || 0;
//   });

//   const finalTotal: any = {
//     name: 'एकूण',
//     sub: 0,
//     'एकूण': 0,
//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0,
//     net_नवीन: 0,
//     net_नूतनीकरण: 0,
//     net_नूतनीकरणबाकी: 0,
//     net_एकूण: 0,
//     net_amount: 0,
//     yojana_नवीन: 0,
//     yojana_नूतनीकरण: 0,
//     yojana_नूतनीकरणबाकी: 0,
//     yojana_एकूण: 0,
//     yojana_amount: 0,
//     ठेवीदार: 0,
//     देणगी: 0,
//     देणगी_amount: 0,
//     pending_amount: 0
//   };

//   this.subTypesName.forEach((b: any) => {
//     if (!b.isVisible) return;
//     const key = this.getKey(b.name);

//     finalTotal[key + '_नवीन'] = 0;
//     finalTotal[key + '_नूतनीकरण'] = 0;
//     finalTotal[key + '_नूतनीकरणबाकी'] = 0;
//     finalTotal[key + '_एकूण'] = 0;
//   });

//   this.finalData = [];

//   const OFFICE_REP_ORDER = [
//     'दयानंद शिवशिवकर',
//     'प्रदीप निकम',
//     'धनाजी जाधव',
//     'राजेश गावडे',
//     'संजय शिवगण',
//     'कार्यालय-वर्गणी विक्री विभाग'
//   ];

//   const uniqueOfficeReps = (this.uniqueData(
//     this.offrepwiseData,
//     (a: any) => a.office_rep_name
//   ) as any[]).sort((a: any, b: any) => {
//     const nameA = (a.office_rep_name || '').trim();
//     const nameB = (b.office_rep_name || '').trim();
//     const indexA = OFFICE_REP_ORDER.indexOf(nameA);
//     const indexB = OFFICE_REP_ORDER.indexOf(nameB);
//     if (indexA !== -1 && indexB !== -1) return indexA - indexB;
//     if (indexA !== -1) return -1;
//     if (indexB !== -1) return 1;
//     return nameA.localeCompare(nameB);
//   });

//   for (const officeRep of uniqueOfficeReps) {

//     const officeRepData = this.offrepwiseData.filter(
//       (a: any) => a.office_rep_name === officeRep.office_rep_name
//     );

//     const officeTotal: any = {
//       name: officeRep.office_rep_name + ' - एकूण',
//       isOfficeRepTotal: true,
//       sub: 0,
//       'एकूण': 0,
//       'नवीन': 0,
//       'नूतनीकरण': 0,
//       'नूतनीकरणबाकी': 0,
//       net_नवीन: 0,
//       net_नूतनीकरण: 0,
//       net_नूतनीकरणबाकी: 0,
//       net_एकूण: 0,
//       net_amount: 0,
//       yojana_नवीन: 0,
//       yojana_नूतनीकरण: 0,
//       yojana_नूतनीकरणबाकी: 0,
//       yojana_एकूण: 0,
//       yojana_amount: 0,
//       ठेवीदार: 0,
//       देणगी: 0,
//       देणगी_amount: 0,
//       pending_amount: 0
//     };

//     this.subTypesName.forEach((b: any) => {
//       if (!b.isVisible) return;
//       const key = this.getKey(b.name);
//       officeTotal[key + '_नवीन'] = 0;
//       officeTotal[key + '_नूतनीकरण'] = 0;
//       officeTotal[key + '_नूतनीकरणबाकी'] = 0;
//       officeTotal[key + '_एकूण'] = 0;
//     });

//     const today = new Date();
//     today.setMonth(today.getMonth() + 1);
//     const processedRep = new Set();

//     for (const record of officeRepData) {

//       const subType = record.subscription_type || '';
//       const key = this.getKey(subType);
//       const isFuture = new Date(record.sub_perid_to_date) > today;
//       const amt = parseFloat(record.total_amt || 0);
//       const repKey = normalize(record.rep_name);
//       const donation = donationMap[repKey] || { count: 0, amount: 0 };
//       const pendingAmt = pendingMap[repKey] || 0;

//       // ================= DEPOSIT =================
//       if (subType === DEPOSIT_TYPE && key) {
//         officeTotal['ठेवीदार']++;
//         finalTotal['ठेवीदार']++;

//         if (record.rcpt_type === 'New') {
//           officeTotal[key + '_नवीन']++;
//           finalTotal[key + '_नवीन']++;
//         } else {
//           officeTotal[key + '_नूतनीकरण']++;
//           finalTotal[key + '_नूतनीकरण']++;
//         }

//         // ✅ FIX: Always add amount
//         officeTotal[key + '_एकूण'] = (officeTotal[key + '_एकूण'] || 0) + amt;
//         finalTotal[key + '_एकूण'] = (finalTotal[key + '_एकूण'] || 0) + amt;
//       }

//       // ================= NET =================
//       if (NET_TYPES.includes(subType)) {
//         if (isFuture) {
//           if (record.rcpt_type === 'New') {
//             officeTotal.net_नवीन++;
//             finalTotal.net_नवीन++;
//           } else {
//             officeTotal.net_नूतनीकरण++;
//             finalTotal.net_नूतनीकरण++;
//           }
//         } else {
//           officeTotal.net_नूतनीकरणबाकी++;
//           finalTotal.net_नूतनीकरणबाकी++;
//         }

//         // ✅ FIX: Always add amount
//         officeTotal.net_amount = (officeTotal.net_amount || 0) + amt;
//         finalTotal.net_amount = (finalTotal.net_amount || 0) + amt;
//         officeTotal.net_एकूण++;
//         finalTotal.net_एकूण++;
//       }

//       // ================= YOJANA =================
//       if (!EXCLUDE_YOJANA.includes(subType)) {
//         if (isFuture) {
//           if (record.rcpt_type === 'New') {
//             officeTotal.yojana_नवीन++;
//             finalTotal.yojana_नवीन++;
//           } else {
//             officeTotal.yojana_नूतनीकरण++;
//             finalTotal.yojana_नूतनीकरण++;
//           }
//         } else {
//           officeTotal.yojana_नूतनीकरणबाकी++;
//           finalTotal.yojana_नूतनीकरणबाकी++;
//         }

//         // ✅ FIX: Always add amount
//         officeTotal.yojana_amount = (officeTotal.yojana_amount || 0) + amt;
//         finalTotal.yojana_amount = (finalTotal.yojana_amount || 0) + amt;
//         officeTotal.yojana_एकूण++;
//         finalTotal.yojana_एकूण++;
//       }

//       // ================= SUBTYPE (non-deposit) =================
//       if (key && subType !== DEPOSIT_TYPE) {
//         if (isFuture) {
//           if (record.rcpt_type === 'New') {
//             officeTotal[key + '_नवीन']++;
//             finalTotal[key + '_नवीन']++;
//           } else {
//             officeTotal[key + '_नूतनीकरण']++;
//             finalTotal[key + '_नूतनीकरण']++;
//           }
//         } else {
//           officeTotal[key + '_नूतनीकरणबाकी']++;
//           finalTotal[key + '_नूतनीकरणबाकी']++;
//         }

//         // ✅ FIX: Always add amount
//         officeTotal[key + '_एकूण'] = (officeTotal[key + '_एकूण'] || 0) + amt;
//         finalTotal[key + '_एकूण'] = (finalTotal[key + '_एकूण'] || 0) + amt;
//       }

//       // ================= MAIN TOTAL =================
//       if (subType !== DEPOSIT_TYPE) {
//         officeTotal.sub++;
//         finalTotal.sub++;

//         if (isFuture) {
//           if (record.rcpt_type === 'New') {
//             officeTotal['नवीन']++;
//             finalTotal['नवीन']++;
//           } else {
//             officeTotal['नूतनीकरण']++;
//             finalTotal['नूतनीकरण']++;
//           }
//         } else {
//           officeTotal['नूतनीकरणबाकी']++;
//           finalTotal['नूतनीकरणबाकी']++;
//         }

//         // ✅ FIX: Always add amount (this is the critical fix for एकूण)
//         officeTotal['एकूण'] = (officeTotal['एकूण'] || 0) + amt;
//         finalTotal['एकूण'] = (finalTotal['एकूण'] || 0) + amt;
//       }

//       // ================= DONATION & PENDING =================
//       if (!processedRep.has(repKey)) {
//         if (donation.count) {
//           officeTotal['देणगी'] += donation.count;
//           officeTotal['देणगी_amount'] += donation.amount;
//           finalTotal['देणगी'] += donation.count;
//           finalTotal['देणगी_amount'] += donation.amount;
//         }
//         if (pendingAmt) {
//           officeTotal['pending_amount'] += pendingAmt;
//           finalTotal['pending_amount'] += pendingAmt;
//         }
//         processedRep.add(repKey);
//       }
//     }

//     this.finalData.push([officeTotal]);
//   }

//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }
  
  getRowTotal(row: any): number {
    let total = 0;
  
    // Net amount
    // total += Number(row.net_amount || 0);
  
    // // Yojana amount
    // total += Number(row.yojana_amount || 0);
  
    // Main total amount
    total += Number(row['एकूण'] || 0);

     // ✅ ADD THIS (Deposit amount)
  const depositKey = this.getKey('मुदत ठेव (पंचवार्षिक वर्गणीदार)');
  total += Number(row[depositKey + '_एकूण'] || 0);
  
    // Sub types amount
    // this.subTypesName.forEach((sub: any) => {
    //   if (sub.isVisible) {
    //     const key = this.getKey(sub.name);
    //     total += Number(row[key + '_एकूण'] || 0);
    //   }
    // });
  
    // Donation
    total += Number(row['देणगी_amount'] || 0);
  
    // Pending
    total += Number(row['pending_amount'] || 0);
  
    return total;
  }
  
  
  getDistrictGroups(repData: any[]): any[] {
  
    if (!Array.isArray(repData)) return [];
  
    const map = new Map();
  
    for (const row of repData) {
  
      if (row.isOfficeRepTotal) continue;
  
      const dist = row.rep_district || 'Unknown';
  
      if (!map.has(dist)) {
        map.set(dist, { rows: [], total: null });
      }
  
      map.get(dist).rows.push(row);
    }
  
    map.forEach((value) => {
  
      const total: any = {
        sub: 0,
        'एकूण': 0,
        'नवीन': 0,
        'नूतनीकरण': 0,
        'नूतनीकरणबाकी': 0,
  
        net_नवीन: 0,
        net_नूतनीकरण: 0,
        net_एकूण: 0,
        net_amount: 0,
  
        yojana_नवीन: 0,
        yojana_नूतनीकरण: 0,
        yojana_एकूण: 0,
        yojana_amount: 0,
  
        ठेवीदार: 0,
        देणगी: 0,
        देणगी_amount: 0
      };
  
      // ✅ dynamic subtype init
      this.subTypesName.forEach((b: any) => {
        if (!b.isVisible) return;
  
        const key = this.getKey(b.name);
  
        total[key + '_नवीन'] = 0;
        total[key + '_नूतनीकरण'] = 0;
        total[key + '_नूतनीकरणबाकी'] = 0;
        total[key + '_एकूण'] = 0;
      });
  
      // ✅ SAFE SUMMATION (IMPORTANT FIX)
      value.rows.forEach((r: any) => {
        Object.keys(r).forEach((k) => {
          if (typeof r[k] === 'number') {
            total[k] = (total[k] || 0) + (r[k] || 0);
          }
        });
      });
  
      total['name'] = 'एकूण';
      total['rep_district'] = value.rows[0]?.rep_district || 'Unknown';
  
      value.total = total;
    });
  
    return Array.from(map.values());
  }

//NEW CORRECT CODE 
// setData() {

//   if (!this.offrepwiseData) return;

//   const NET_TYPES = [
//     'वार्षिक',
//     'त्रैवार्षिक',
//     'पंचवार्षिक',
//     'ऑनलाईन अंक सहामाही',
//     'ऑनलाईन अंक वार्षिक'
//   ];

//   const EXCLUDE_YOJANA = [
//     ...NET_TYPES,
//     'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
//   ];

//   const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

//   const normalize = (val: any) =>
//     (val || '')
//       .toString()
//       .trim()
//       .replace(/\s+/g, ' ')
//       .replace(/[^\w\u0900-\u097F ]/g, '')
//       .toLowerCase();

//   // =========================================================
//   // PENDING CREDIT VOUCHER MAP (REPRESENTATIVE WISE)
//   // =========================================================

//   const pendingMap: any = {};

//   (this.getallVouchersData || []).forEach((v: any) => {

//     // IMPORTANT:
//     // office representative name from voucher table
//     const officeRepName =
//       v.office_rep_name ||
//       v.officerep_name ||
//       v.office_rep ||
//       v.rep_office_name ||
//       '';

//     const officeKey = normalize(officeRepName);

//     if (!officeKey) return;

//     if (!pendingMap[officeKey]) {
//       pendingMap[officeKey] = 0;
//     }

//     pendingMap[officeKey] += Number(v.remaining_amt) || 0;
//   });

//   // =========================================================
//   // FINAL TOTAL
//   // =========================================================

//   const finalTotal: any = {
//     name: 'एकूण',
//     sub: 0,
//     'एकूण': 0,
//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0,

//     net_नवीन: 0,
//     net_नूतनीकरण: 0,
//     net_नूतनीकरणबाकी: 0,
//     net_एकूण: 0,
//     net_amount: 0,

//     yojana_नवीन: 0,
//     yojana_नूतनीकरण: 0,
//     yojana_नूतनीकरणबाकी: 0,
//     yojana_एकूण: 0,
//     yojana_amount: 0,

//     ठेवीदार: 0,

//     देणगी: 0,
//     देणगी_amount: 0,

//     pending_amount: 0
//   };

//   // =========================================================
//   // SUB TYPES INIT
//   // =========================================================

//   this.subTypesName.forEach((b: any) => {

//     if (!b.isVisible) return;

//     const key = this.getKey(b.name);

//     finalTotal[key + '_नवीन'] = 0;
//     finalTotal[key + '_नूतनीकरण'] = 0;
//     finalTotal[key + '_नूतनीकरणबाकी'] = 0;
//     finalTotal[key + '_एकूण'] = 0;
//   });

//   this.finalData = [];

//   // =========================================================
//   // OFFICE REPRESENTATIVE ORDER
//   // =========================================================

//   const OFFICE_REP_ORDER = [
//     'दयानंद शिवशिवकर',
//     'प्रदीप निकम',
//     'धनाजी जाधव',
//     'राजेश गावडे',
//     'संजय शिवगण',
//     'कार्यालय-वर्गणी विक्री विभाग'
//   ];

//   const uniqueOfficeReps = (this.uniqueData(
//     this.offrepwiseData,
//     (a: any) => a.office_rep_name
//   ) as any[]).sort((a: any, b: any) => {

//     const nameA = (a.office_rep_name || '').trim();
//     const nameB = (b.office_rep_name || '').trim();

//     const indexA = OFFICE_REP_ORDER.indexOf(nameA);
//     const indexB = OFFICE_REP_ORDER.indexOf(nameB);

//     if (indexA !== -1 && indexB !== -1) {
//       return indexA - indexB;
//     }

//     if (indexA !== -1) return -1;
//     if (indexB !== -1) return 1;

//     return nameA.localeCompare(nameB);
//   });

//   // =========================================================
//   // LOOP OFFICE REPRESENTATIVES
//   // =========================================================

//   for (const officeRep of uniqueOfficeReps) {

//     const officeRepData = this.offrepwiseData.filter(
//       (a: any) =>
//         normalize(a.office_rep_name) ===
//         normalize(officeRep.office_rep_name)
//     );

//     const officeTotal: any = {

//       name: officeRep.office_rep_name + ' - एकूण',
//       isOfficeRepTotal: true,

//       sub: 0,

//       'एकूण': 0,
//       'नवीन': 0,
//       'नूतनीकरण': 0,
//       'नूतनीकरणबाकी': 0,

//       net_नवीन: 0,
//       net_नूतनीकरण: 0,
//       net_नूतनीकरणबाकी: 0,
//       net_एकूण: 0,
//       net_amount: 0,

//       yojana_नवीन: 0,
//       yojana_नूतनीकरण: 0,
//       yojana_नूतनीकरणबाकी: 0,
//       yojana_एकूण: 0,
//       yojana_amount: 0,

//       ठेवीदार: 0,

//       देणगी: 0,
//       देणगी_amount: 0,

//       pending_amount: 0
//     };

//     // =========================================================
//     // INIT SUB TYPES
//     // =========================================================

//     this.subTypesName.forEach((b: any) => {

//       if (!b.isVisible) return;

//       const key = this.getKey(b.name);

//       officeTotal[key + '_नवीन'] = 0;
//       officeTotal[key + '_नूतनीकरण'] = 0;
//       officeTotal[key + '_नूतनीकरणबाकी'] = 0;
//       officeTotal[key + '_एकूण'] = 0;
//     });

//     // =========================================================
//     // TODAY CHECK
//     // =========================================================

//     const today = new Date();
//     today.setMonth(today.getMonth() + 1);

//     // =========================================================
//     // REPRESENTATIVE WISE PENDING AMOUNT
//     // =========================================================

//     const officeRepKey = normalize(officeRep.office_rep_name);

//     const repPendingAmount = pendingMap[officeRepKey] || 0;

//     officeTotal['pending_amount'] = repPendingAmount;

//     finalTotal['pending_amount'] += repPendingAmount;

//     // =========================================================
//     // RECORD LOOP
//     // =========================================================

//     for (const record of officeRepData) {

//       const subType = record.subscription_type || '';

//       const key = this.getKey(subType);

//       const isFuture =
//         new Date(record.sub_perid_to_date) > today;

//       const amt = parseFloat(record.total_amt || 0);

//       // =====================================================
//       // DEPOSIT
//       // =====================================================

//       if (subType === DEPOSIT_TYPE && key) {

//         officeTotal['ठेवीदार']++;
//         finalTotal['ठेवीदार']++;

//         if (record.rcpt_type === 'New') {

//           officeTotal[key + '_नवीन']++;
//           finalTotal[key + '_नवीन']++;

//         } else {

//           officeTotal[key + '_नूतनीकरण']++;
//           finalTotal[key + '_नूतनीकरण']++;
//         }

//         officeTotal[key + '_एकूण'] =
//           (officeTotal[key + '_एकूण'] || 0) + amt;

//         finalTotal[key + '_एकूण'] =
//           (finalTotal[key + '_एकूण'] || 0) + amt;
//       }

//       // =====================================================
//       // NET
//       // =====================================================

//       if (NET_TYPES.includes(subType)) {

//         if (isFuture) {

//           if (record.rcpt_type === 'New') {

//             officeTotal.net_नवीन++;
//             finalTotal.net_नवीन++;

//           } else {

//             officeTotal.net_नूतनीकरण++;
//             finalTotal.net_नूतनीकरण++;
//           }

//         } else {

//           officeTotal.net_नूतनीकरणबाकी++;
//           finalTotal.net_नूतनीकरणबाकी++;
//         }

//         officeTotal.net_amount =
//           (officeTotal.net_amount || 0) + amt;

//         finalTotal.net_amount =
//           (finalTotal.net_amount || 0) + amt;

//         officeTotal.net_एकूण++;
//         finalTotal.net_एकूण++;
//       }

//       // =====================================================
//       // YOJANA
//       // =====================================================

//       if (!EXCLUDE_YOJANA.includes(subType)) {

//         if (isFuture) {

//           if (record.rcpt_type === 'New') {

//             officeTotal.yojana_नवीन++;
//             finalTotal.yojana_नवीन++;

//           } else {

//             officeTotal.yojana_नूतनीकरण++;
//             finalTotal.yojana_नूतनीकरण++;
//           }

//         } else {

//           officeTotal.yojana_नूतनीकरणबाकी++;
//           finalTotal.yojana_नूतनीकरणबाकी++;
//         }

//         officeTotal.yojana_amount =
//           (officeTotal.yojana_amount || 0) + amt;

//         finalTotal.yojana_amount =
//           (finalTotal.yojana_amount || 0) + amt;

//         officeTotal.yojana_एकूण++;
//         finalTotal.yojana_एकूण++;
//       }

//       // =====================================================
//       // SUBTYPE
//       // =====================================================

//       if (key && subType !== DEPOSIT_TYPE) {

//         if (isFuture) {

//           if (record.rcpt_type === 'New') {

//             officeTotal[key + '_नवीन']++;
//             finalTotal[key + '_नवीन']++;

//           } else {

//             officeTotal[key + '_नूतनीकरण']++;
//             finalTotal[key + '_नूतनीकरण']++;
//           }

//         } else {

//           officeTotal[key + '_नूतनीकरणबाकी']++;
//           finalTotal[key + '_नूतनीकरणबाकी']++;
//         }

//         officeTotal[key + '_एकूण'] =
//           (officeTotal[key + '_एकूण'] || 0) + amt;

//         finalTotal[key + '_एकूण'] =
//           (finalTotal[key + '_एकूण'] || 0) + amt;
//       }

//       // =====================================================
//       // MAIN TOTAL
//       // =====================================================

//       if (subType !== DEPOSIT_TYPE) {

//         officeTotal.sub++;
//         finalTotal.sub++;

//         if (isFuture) {

//           if (record.rcpt_type === 'New') {

//             officeTotal['नवीन']++;
//             finalTotal['नवीन']++;

//           } else {

//             officeTotal['नूतनीकरण']++;
//             finalTotal['नूतनीकरण']++;
//           }

//         } else {

//           officeTotal['नूतनीकरणबाकी']++;
//           finalTotal['नूतनीकरणबाकी']++;
//         }

//         officeTotal['एकूण'] =
//           (officeTotal['एकूण'] || 0) + amt;

//         finalTotal['एकूण'] =
//           (finalTotal['एकूण'] || 0) + amt;
//       }
//     }

//     // =========================================================
//     // PUSH OFFICE TOTAL
//     // =========================================================

//     this.finalData.push([officeTotal]);
//   }

//   // =========================================================
//   // FINAL TOTAL PUSH
//   // =========================================================

//   this.finalData.push(finalTotal);

//   this.isLoading = false;
// }
   
   createEmptyTotal(ref: any): any {
     const total: any = {
       name: 'एकूण',
       district_name: ref.district_name,
       office_rep_name: ref.office_rep_name,
       sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
     };
   
     this.subTypesName.forEach(sub => {
       if (sub.isVisible) {
         const key = this.getKey(sub.name);
         total[key + '_नवीन'] = 0;
         total[key + '_नूतनीकरण'] = 0;
         total[key + '_एकूण'] = 0;
         total[key + '_नूतनीकरणबाकी'] = 0;
       }
     });
   
     return total;
   }

   addToTotal(total: any, record: any): void {
     total.sub += record.sub || 0;
     total['एकूण'] += record['एकूण'] || 0;
     total['नवीन'] += record['नवीन'] || 0;
     total['नूतनीकरण'] += record['नूतनीकरण'] || 0;
     total['नूतनीकरणबाकी'] += record['नूतनीकरणबाकी'] || 0;
   
     this.subTypesName.forEach(sub => {
       if (sub.isVisible) {
         const key = this.getKey(sub.name);
         total[key + '_नवीन'] += record[key + '_नवीन'] || 0;
         total[key + '_नूतनीकरण'] += record[key + '_नूतनीकरण'] || 0;
         total[key + '_एकूण'] += record[key + '_एकूण'] || 0;
         total[key + '_नूतनीकरणबाकी'] += record[key + '_नूतनीकरणबाकी'] || 0;
       }
     });
   }
   
     getKey(name) {
       return name.replaceAll(' ', '_');
     }
   
     uniqueData(data, key) {
       return [...new Map(data.map((a) => [key(a), a])).values()];
     }
   
     exportExcel(fileName) {
       /* table id is passed over here */
       let element = document.getElementById('print-section');
       const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
   
       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
   
       /* save to file */
       XLSX.writeFile(wb, fileName + '.xlsx');
     }

     setData() {

  if (!this.offrepwiseData) return;

  const NET_TYPES = [
    'वार्षिक',
    'त्रैवार्षिक',
    'पंचवार्षिक',
    'ऑनलाईन अंक सहामाही',
    'ऑनलाईन अंक वार्षिक'
  ];

  const EXCLUDE_YOJANA = [
    ...NET_TYPES,
    'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
  ];

  const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';
  const OTHER_REP = 'इतर';

  const normalize = (val: any) =>
    (val || '')
      .toString()
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/[^\w\u0900-\u097F ]/g, '')
      .toLowerCase();

  // =========================================================
  // DONATION MAP
  // =========================================================

  // const allVouchers = (
  //   Array.isArray(this.expenseLedgerData)
  //     ? this.expenseLedgerData
  //     : []
  // ).reduce((acc: any[], exp: any) => {

  //   const expName = normalize(exp.exp_name);
  //   const subExpName = normalize(exp.sub_exp_name);

  //   const isDonation =
  //     expName.includes('देणगी') ||
  //     subExpName.includes('वर्गणी विभाग');

  //   if (isDonation && Array.isArray(exp.vouchers)) {
  //     acc.push(...exp.vouchers);
  //   }

  //   return acc;

  // }, []);

  const expenseData = Array.isArray(this.expenseLedgerData)
  ? this.expenseLedgerData
  : (this.expenseLedgerData ? [this.expenseLedgerData] : []);

const allVouchers = expenseData.reduce((acc: any[], exp: any) => {

  const expName = normalize(exp.exp_name);
  const subExpName = normalize(exp.sub_exp_name);

  const isDonation =
    expName.includes('देणगी') ||
    subExpName.includes('वर्गणी विभाग');

  if (isDonation && Array.isArray(exp.vouchers)) {
    acc.push(...exp.vouchers);
  }

  return acc;

}, []);

console.log('expenseLedgerData', this.expenseLedgerData);
console.log('expenseData', expenseData);
console.log('allVouchers', allVouchers);
// console.log('donationMap', donationMap);

  const donationMap: any = {};

  const start = new Date(this.startDate);
  const end = new Date(this.endDate);

  allVouchers.forEach((v: any) => {

    const rep = normalize(v.rep_name);

    if (!rep) return;

    const vDate = new Date(v.voucher_date);

    if (isNaN(vDate.getTime())) return;
    if (vDate < start || vDate > end) return;

    if (!donationMap[rep]) {

      donationMap[rep] = {
        count: 0,
        amount: 0
      };
    }

    donationMap[rep].count += 1;
    donationMap[rep].amount += Number(v.exp_amt) || 0;

  });

  // =========================================================
  // REPRESENTATIVE MASTER MAP
  // =========================================================

  const representativeMasterMap: any = {};

  (this.offrepwiseData || []).forEach((r: any) => {

    const repKey = normalize(r.rep_name);

    if (!repKey) return;

    if (
      !representativeMasterMap[repKey] &&
      (
        r.office_rep_name ||
        r.rep_district ||
        r.rep_taluka
      )
    ) {

      representativeMasterMap[repKey] = {

        office_rep_name: r.office_rep_name,
        rep_district: r.rep_district,
        rep_taluka: r.rep_taluka
      };
    }
  });

  // =========================================================
  // PENDING MAP OFFICE REP WISE
  // =========================================================

  const pendingOfficeMap: any = {};
  const pendingRepMap: any = {};

  (this.getallVouchersData || []).forEach((v: any) => {

    const repName =
      v.rep_name ||
      v.representative_name ||
      v.name ||
      '';

    const repKey = normalize(repName);

    const pendingAmount =
      parseFloat(v.remaining_amt) ||
      parseFloat(v.pending_amount) ||
      0;

    if (!pendingAmount) return;

    // =====================================================
    // STRICT OFFICE REP DETECTION
    // =====================================================

    let officeRepName =
      (
        v.office_rep_name ||
        v.officerep_name ||
        ''
      ).toString().trim();

    // =====================================================
    // IF EMPTY -> TRY MASTER MAP
    // =====================================================

    if (
      !officeRepName ||
      officeRepName === '-' ||
      officeRepName === 'Unknown' ||
      officeRepName === 'null'
    ) {

      officeRepName =
        representativeMasterMap[repKey]?.office_rep_name || '';
    }

    // =====================================================
    // STILL EMPTY -> इतर
    // =====================================================

    if (
      !officeRepName ||
      officeRepName === '-' ||
      officeRepName === 'Unknown' ||
      officeRepName === 'null'
    ) {

      officeRepName = OTHER_REP;
    }

    officeRepName = officeRepName.toString().trim();

    const officeKey = normalize(officeRepName);

    // =====================================================
    // OFFICE REP WISE PENDING
    // =====================================================

    if (!pendingOfficeMap[officeKey]) {
      pendingOfficeMap[officeKey] = 0;
    }

    pendingOfficeMap[officeKey] += pendingAmount;

    // =====================================================
    // REP WISE PENDING
    // =====================================================

    if (!pendingRepMap[repKey]) {

      pendingRepMap[repKey] = {
        amount: 0,
        office_rep_name: officeRepName
      };
    }

    pendingRepMap[repKey].amount += pendingAmount;

  });

  // =========================================================
  // ADD PENDING ONLY OFFICE REP
  // =========================================================

  Object.keys(pendingOfficeMap).forEach((officeKey: any) => {

    const exists = (this.offrepwiseData || []).some(
      (x: any) =>
        normalize(x.office_rep_name) === officeKey
    );

    if (!exists) {

      this.offrepwiseData.push({

        office_rep_name:
          officeKey === normalize(OTHER_REP)
            ? OTHER_REP
            : officeKey,

        rep_name: '',
        rep_district: '',
        rep_taluka: '',

        subscription_type: '',
        rcpt_type: '',
        total_amt: 0,

        sub_perid_to_date: new Date(),

        isPendingOnlyRecord: true
      });
    }

  });

  // =========================================================
  // FINAL TOTAL
  // =========================================================

  const finalTotal: any = {

    name: 'एकूण',

    sub: 0,

    'एकूण': 0,
    'नवीन': 0,
    'नूतनीकरण': 0,
    'नूतनीकरणबाकी': 0,

    net_नवीन: 0,
    net_नूतनीकरण: 0,
    net_नूतनीकरणबाकी: 0,
    net_एकूण: 0,
    net_amount: 0,

    yojana_नवीन: 0,
    yojana_नूतनीकरण: 0,
    yojana_नूतनीकरणबाकी: 0,
    yojana_एकूण: 0,
    yojana_amount: 0,

    ठेवीदार: 0,

    देणगी: 0,
    देणगी_amount: 0,

    pending_amount: 0
  };

  this.subTypesName.forEach((b: any) => {

    if (!b.isVisible) return;

    const key = this.getKey(b.name);

    finalTotal[key + '_नवीन'] = 0;
    finalTotal[key + '_नूतनीकरण'] = 0;
    finalTotal[key + '_नूतनीकरणबाकी'] = 0;
    finalTotal[key + '_एकूण'] = 0;

  });

  this.finalData = [];

  // =========================================================
  // OFFICE REP ORDER
  // =========================================================

  const OFFICE_REP_ORDER = [
    'दयानंद शिवशिवकर',
    'प्रदीप निकम',
    'धनाजी जाधव',
    'राजेश गावडे',
    'संजय शिवगण',
    'कार्यालय-वर्गणी विक्री विभाग',
    'इतर'
  ];

  const updatedOfficeReps = (this.uniqueData(
    this.offrepwiseData,
    (a: any) => a.office_rep_name
  ) as any[]).sort((a: any, b: any) => {

    const nameA = (a.office_rep_name || '').trim();
    const nameB = (b.office_rep_name || '').trim();

    const indexA = OFFICE_REP_ORDER.indexOf(nameA);
    const indexB = OFFICE_REP_ORDER.indexOf(nameB);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;

    return nameA.localeCompare(nameB);

  });

  // =========================================================
  // MAIN LOOP
  // =========================================================

  for (const officeRep of updatedOfficeReps) {

    const officeRepData = this.offrepwiseData.filter(
      (a: any) =>
        normalize(a.office_rep_name) ===
        normalize(officeRep.office_rep_name)
    );

    const officeKey = normalize(
      officeRep.office_rep_name || OTHER_REP
    );

    const officeTotal: any = {

      name: officeRep.office_rep_name + ' - एकूण',

      isOfficeRepTotal: true,

      sub: 0,

      'एकूण': 0,
      'नवीन': 0,
      'नूतनीकरण': 0,
      'नूतनीकरणबाकी': 0,

      net_नवीन: 0,
      net_नूतनीकरण: 0,
      net_नूतनीकरणबाकी: 0,
      net_एकूण: 0,
      net_amount: 0,

      yojana_नवीन: 0,
      yojana_नूतनीकरण: 0,
      yojana_नूतनीकरणबाकी: 0,
      yojana_एकूण: 0,
      yojana_amount: 0,

      ठेवीदार: 0,

      देणगी: 0,
      देणगी_amount: 0,

      // =====================================================
      // CORRECT PENDING
      // =====================================================

      pending_amount:
        Number(pendingOfficeMap[officeKey]) || 0
    };

    // =====================================================
    // FINAL TOTAL PENDING
    // =====================================================

    finalTotal['pending_amount'] +=
      Number(pendingOfficeMap[officeKey]) || 0;

    this.subTypesName.forEach((b: any) => {

      if (!b.isVisible) return;

      const key = this.getKey(b.name);

      officeTotal[key + '_नवीन'] = 0;
      officeTotal[key + '_नूतनीकरण'] = 0;
      officeTotal[key + '_नूतनीकरणबाकी'] = 0;
      officeTotal[key + '_एकूण'] = 0;

    });

    const today = new Date();
    today.setMonth(today.getMonth() + 1);

    const processedRep = new Set();

    for (const record of officeRepData) {

      if (record.isPendingOnlyRecord) {
        continue;
      }

      const subType = record.subscription_type || '';

      const key = this.getKey(subType);

      const isFuture =
        new Date(record.sub_perid_to_date) > today;

      const amt = Number(record.total_amt) || 0;

      const repKey = normalize(record.rep_name);

      const donation = donationMap[repKey] || {
        count: 0,
        amount: 0
      };

      // =====================================================
      // DEPOSIT
      // =====================================================

      if (subType === DEPOSIT_TYPE && key) {

        officeTotal['ठेवीदार']++;
        finalTotal['ठेवीदार']++;

        if (record.rcpt_type === 'New') {

          officeTotal[key + '_नवीन']++;
          finalTotal[key + '_नवीन']++;

        } else {

          officeTotal[key + '_नूतनीकरण']++;
          finalTotal[key + '_नूतनीकरण']++;
        }

        officeTotal[key + '_एकूण'] =
          (officeTotal[key + '_एकूण'] || 0) + amt;

        finalTotal[key + '_एकूण'] =
          (finalTotal[key + '_एकूण'] || 0) + amt;
      }

      // =====================================================
      // NET
      // =====================================================

      if (NET_TYPES.includes(subType)) {

        if (isFuture) {

          if (record.rcpt_type === 'New') {

            officeTotal.net_नवीन++;
            finalTotal.net_नवीन++;

          } else {

            officeTotal.net_नूतनीकरण++;
            finalTotal.net_नूतनीकरण++;
          }

        } else {

          officeTotal.net_नूतनीकरणबाकी++;
          finalTotal.net_नूतनीकरणबाकी++;
        }

        officeTotal.net_amount =
          (officeTotal.net_amount || 0) + amt;

        finalTotal.net_amount =
          (finalTotal.net_amount || 0) + amt;

        officeTotal.net_एकूण++;
        finalTotal.net_एकूण++;
      }

      // =====================================================
      // YOJANA
      // =====================================================

      if (!EXCLUDE_YOJANA.includes(subType)) {

        if (isFuture) {

          if (record.rcpt_type === 'New') {

            officeTotal.yojana_नवीन++;
            finalTotal.yojana_नवीन++;

          } else {

            officeTotal.yojana_नूतनीकरण++;
            finalTotal.yojana_नूतनीकरण++;
          }

        } else {

          officeTotal.yojana_नूतनीकरणबाकी++;
          finalTotal.yojana_नूतनीकरणबाकी++;
        }

        officeTotal.yojana_amount =
          (officeTotal.yojana_amount || 0) + amt;

        finalTotal.yojana_amount =
          (finalTotal.yojana_amount || 0) + amt;

        officeTotal.yojana_एकूण++;
        finalTotal.yojana_एकूण++;
      }

      // =====================================================
      // SUBTYPE
      // =====================================================

      if (key && subType !== DEPOSIT_TYPE) {

        if (isFuture) {

          if (record.rcpt_type === 'New') {

            officeTotal[key + '_नवीन']++;
            finalTotal[key + '_नवीन']++;

          } else {

            officeTotal[key + '_नूतनीकरण']++;
            finalTotal[key + '_नूतनीकरण']++;
          }

        } else {

          officeTotal[key + '_नूतनीकरणबाकी']++;
          finalTotal[key + '_नूतनीकरणबाकी']++;
        }

        officeTotal[key + '_एकूण'] =
          (officeTotal[key + '_एकूण'] || 0) + amt;

        finalTotal[key + '_एकूण'] =
          (finalTotal[key + '_एकूण'] || 0) + amt;
      }

      // =====================================================
      // MAIN TOTAL
      // =====================================================

      if (subType !== DEPOSIT_TYPE) {

        officeTotal.sub++;
        finalTotal.sub++;

        if (isFuture) {

          if (record.rcpt_type === 'New') {

            officeTotal['नवीन']++;
            finalTotal['नवीन']++;

          } else {

            officeTotal['नूतनीकरण']++;
            finalTotal['नूतनीकरण']++;
          }

        } else {

          officeTotal['नूतनीकरणबाकी']++;
          finalTotal['नूतनीकरणबाकी']++;
        }

        officeTotal['एकूण'] =
          (officeTotal['एकूण'] || 0) + amt;

        finalTotal['एकूण'] =
          (finalTotal['एकूण'] || 0) + amt;
      }

      // =====================================================
      // DONATION
      // =====================================================

      if (!processedRep.has(repKey)) {

        officeTotal['देणगी'] += donation.count;
        officeTotal['देणगी_amount'] += donation.amount;

        finalTotal['देणगी'] += donation.count;
        finalTotal['देणगी_amount'] += donation.amount;

        processedRep.add(repKey);
      }
    }

    officeTotal['row_total'] =
      (officeTotal['एकूण'] || 0) +
      (officeTotal['net_amount'] || 0) +
      (officeTotal['yojana_amount'] || 0) +
      (officeTotal['देणगी_amount'] || 0) +
      (officeTotal['pending_amount'] || 0);

    this.finalData.push([officeTotal]);
  }

  finalTotal['row_total'] =
    (finalTotal['एकूण'] || 0) +
    (finalTotal['net_amount'] || 0) +
    (finalTotal['yojana_amount'] || 0) +
    (finalTotal['देणगी_amount'] || 0) +
    (finalTotal['pending_amount'] || 0);

  this.finalData.push(finalTotal);

  this.isLoading = false;
}

   
     //Main Report Method Use in all Printing Page
     show = false
    //  printPage() {
    //    this.show = true
    //    const printContent = document.getElementById('print-section')?.outerHTML;
    //    if (!printContent) {
    //      console.error("Print section not found!");
    //      return;
    //    }
   
    //    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
   
    //    if (printWindow) {
    //      printWindow.document.open();
    //      printWindow.document.write(`
    //             <html>
    //                 <head>
    //                     <title>Print Report</title>
    //                     <style>
    //                         @media print {
    //                             @page { 
    //                                 size: A3 landscape; /* Set A3 size with landscape mode */
    //                                 margin: 5mm; /* Adjust margins */
    //                             }
    //                             body { 
    //                                 font-family: Arial, sans-serif; 
    //                                 font-size: 15px; /* Adjust font size */
    //                                 margin: 0; 
    //                                 padding: 5mm; 
    //                                 line-height: 1.2; 
    //                             }
    //                             table { 
    //                                 width: 100%; 
    //                                 height: 100%;
    //                                 border-collapse: collapse; 
    //                                 table-layout: fixed; /* Prevent column expansion */
    //                                 page-break-inside: avoid; /* Avoid breaking the table */
    //                             }
    //                             th, td { 
    //                                 padding: 2px; 
    //                                 border: 1px solid black; 
    //                                 text-align: center; 
    //                                 font-size: 12px; /* Adjusted font size */
    //                                 line-height: 1.2; 
    //                             }
    //                             .noPrint { 
    //                                 display: none; /* Hide print button */
    //                             }
    //                         }
    //                     </style>
    //                 </head>
    //                 <body>
    //                     <div id="print-section">
    //                         ${printContent}
    //                     </div>
    //                     <script>
    //                         window.onload = function() { 
    //                             window.print(); 
    //                             setTimeout(() => { window.close(); }, 500);
    //                         };
    //                     </script>
    //                 </body>
    //             </html>
    //         `);
    //      printWindow.document.close();
    //    } else {
    //      console.error("Failed to open print window.");
    //    }
    //  }
   


// printPage() {
//   this.show = true;

//   const printContent = document.getElementById('print-section')?.outerHTML;
//   if (!printContent) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

//   if (printWindow) {
//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             @media print {
//               @page { 
//                 size: A3 landscape;
//                 margin: 5mm;
//               }

//               body { 
//                 font-family: Arial, sans-serif; 
//                 font-size: 14px;
//                 margin: 0; 
//                 padding: 5mm; 
//                 line-height: 1.2; 
//               }

//               table { 
//                 width: auto;
//                 border-collapse: collapse; 
//                 table-layout: auto;
//               }

//               /* ✅ HEADER FIX */
//               th { 
//                 padding: 4px 6px; 
//                 border: 1px solid black; 
//                 text-align: center; 
//                 font-size: 12px;

//                 white-space: normal;       /* allow wrap */
//                 word-break: break-word;    /* break long words */
//                 max-width: 120px;          /* control width */
//               }

//               /* ✅ DATA FIX */
//               td { 
//                 padding: 4px 6px; 
//                 border: 1px solid black; 
//                 text-align: center; 
//                 font-size: 12px;

//                 white-space: nowrap;       /* keep data in one line */
//               }

//               .noPrint { 
//                 display: none;
//               }
//             }
//           </style>
//         </head>

//         <body>
//           <div id="print-section">
//             ${printContent}
//           </div>

//           <script>
//             window.onload = function() { 
//               window.print(); 
//               setTimeout(() => { window.close(); }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();

//   } else {
//     console.error("Failed to open print window.");
//   }
// }


printPage() {
  this.show = true;

  const printContent = document.getElementById('print-section')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page { 
                size: A3 landscape;
                margin: 5mm;
              }

              body { 
                font-family: Arial, sans-serif; 
                font-size: 14px;
                margin: 0; 
                padding: 5mm; 
                line-height: 1.2; 
              }

              table { 
                width: auto;
                border-collapse: collapse; 
                table-layout: auto;
              }

              /* HEADER */
              th { 
                padding: 4px 6px; 
                border: 1px solid black; 
                text-align: center; 
                font-size: 12px;
                white-space: normal;
                word-break: break-word;
                max-width: 120px;
              }

              /* DATA */
              td { 
                padding: 4px 6px; 
                border: 1px solid black; 
                text-align: center; 
                font-size: 12px;
                white-space: nowrap;
              }

              /* ✅ FINAL TOTAL ROW BOLD */
              tr:last-child td {
                font-weight: bold;
              }

              /* OPTIONAL: if you specifically use 'एकूण' */
              tr td:first-child:contains("एकूण") {
                font-weight: bold;
              }

              .noPrint { 
                display: none;
              }
            }
          </style>
        </head>

        <body>
          <div id="print-section">
            ${printContent}
          </div>

          <script>
            window.onload = function() { 
              window.print(); 
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();

  } else {
    console.error("Failed to open print window.");
  }
}
}
